import type { Person, Player } from 'state';

export type PlayerNameDisplay = {
  displayName: string;
  nameSearchText: string;
};

export function getPlayerNameDisplay(
  player: Pick<Player, 'name' | 'persons'>,
  persons: Record<string, Person | undefined>,
  showPersonNames: boolean,
): PlayerNameDisplay {
  const personNames = showPersonNames
    ? (player.persons ?? [])
        .map(id => persons?.[id]?.name?.trim())
        .filter(Boolean)
        .join(', ')
    : '';

  return {
    displayName: personNames || player.name,
    nameSearchText: personNames ? `${personNames} ${player.name}` : player.name,
  };
}
